import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppraisalDataService {
  
  constructor(private http: HttpClient) {
  }
   
  private rowDataSubject = new BehaviorSubject<any>(null); // Holds the rowData
  rowData$ = this.rowDataSubject.asObservable(); // Expose it as observable

  private allrowsDataSubject = new BehaviorSubject<any>(null); // Holds the allrowsDataSubjectData
  allrowsData$ = this.allrowsDataSubject.asObservable(); // Expose it as observable

  private gridStateSubject = new BehaviorSubject<any>(null); // Holds the gridStateData
  gridStateData$ = this.gridStateSubject.asObservable(); // Expose it as observable

  // Function to update rowData
  setRowData(data: any) {
    this.rowDataSubject.next(data);
  }

  // Function to update rowData
  getRowData() {
    return this.rowDataSubject.getValue();
  }

  setAllRowsData(data: any) {
    this.allrowsDataSubject.next(data);
  }

  getAllRowsData() {
    return this.allrowsDataSubject.getValue();
  }

  getPriorQuarterAppraisals(activityPropertyMap: { [activityNumber: string]: string }): Observable<{ [activityNumber: string]: any }> {
    const apiUrl = environment.appraisalApiConfig.baseUrl + '/export/priorQuarter';
    return this.http.post<{ [activityNumber: string]: any }>(apiUrl, activityPropertyMap);
  }

  setGridStateData(data: any) {
    this.gridStateSubject.next(data);
  }

  getGridStateData() {
    return this.gridStateSubject.getValue();
  }

  downloadfile(activityNumber: string) {
    const url = environment.appraisalApiConfig.baseUrl +"/file/" + activityNumber;
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
